<template>
  <div class="">
    <div class="tiktok-data-box">
      <p class="mb-0">
        <strong>Tiktok Order Id :</strong>
        <span> {{ tiktokOrderId }}</span>
      </p>
      <p class="mb-0">
        <strong>Shipping Label : </strong>
        <a @click="downloadDocument('SHIPPING_LABEL')">Download</a>
      </p>
      <p class="mb-0">
        <strong>Package Slip : </strong>
        <a @click="downloadDocument('PACKING_SLIP')">Download</a>
      </p>
      <p class="mb-0">
        <strong>Package Slip and Shipping Label : </strong>
        <a @click="downloadDocument('SHIPPING_LABEL_AND_PACKING_SLIP')">Download</a>
      </p>
    </div>
  </div>
</template>

<script>
import TiktokOrderProvider from '@/resources/TiktokOrderProvider'

const TiktokOrderService = new TiktokOrderProvider()
export default {
  props: {
    orderId: {
      type: String,
      default: ''
    },
    tiktokOrderId: {
      type: String,
      default: ''
    }
  },
  methods: {
    async downloadDocument (documentType) {
      try {
        const { data } = await TiktokOrderService.getDocument({
          orderId: this.orderId,
          documentType
        })

        const url = data[0]?.docUrl || null
        if (!url) {
          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Document not found.',
            type: 'error'
          })
          return
        }

        const downloadLink = document.createElement('a')

        downloadLink.href = url
        downloadLink.setAttribute('target', '_blank')
        downloadLink.download = `${documentType}_${this.orderId}.pdf`
        downloadLink.click()
      } catch (error) {
        console.error(`ERROR: ${error.message}`)
      }
    }
  }
}
</script>

<style scoped>
.tiktok-data-box {
  font-size: 12px;
  margin-top: 10px;
  border-radius: 6px;
  padding: 10px;
  background-color: #f0f0f0;
}
</style>
